module.exports = __webpack_public_path__ + "img/monaco-kombat.f1074540.png";